import { registerEnum } from '@adornis/baseql/metadata/register.js';

/**
 * How thorough an import run is. Every level includes the one before it — the question an admin answers is
 * "how much do I distrust what is already there?".
 */
export enum AccountingImportMode {
  /**
   * Files whose content changed, and the references of their schools. Cheap: most runs find nothing to do. This
   * is what runs every night.
   */
  CHANGED_FILES = 'CHANGED_FILES',
  /**
   * Plus the references of EVERY school: persons, mandates and bookings change without any file changing, and
   * nothing else brings such a change to the entries of a school whose files stay the same.
   */
  RESOLVE_ALL = 'RESOLVE_ALL',
  /** Plus every file downloaded and parsed again, changed or not — when the stored entries themselves are in doubt. */
  FULL = 'FULL',
}

registerEnum({ enum: AccountingImportMode, name: 'AccountingImportMode' });
